import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogTitle,
} from '@eliadmin/core/src/components/ui/responsive-dialog';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { Button } from '../ui/button';
import { initCustomerStore } from '@eliadmin/core/src/stores/customer-store';

export const LoggedOffDialog = () => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [open, setOpen] = useState(true);
  const router = useRouter();
  const { t } = useTranslations();

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setOpen(false);
      initCustomerStore(null);
      router.push(ROUTES.SIGN_IN());
    }, 5000);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <ResponsiveDialog open={open} onOpenChange={setOpen}>
      <ResponsiveDialogContent className="flex flex-col gap-4 py-6">
        <ResponsiveDialogTitle hidden>{t('text3145')}</ResponsiveDialogTitle>
        <h2 className="w-full text-center text-2xl font-bold">{t('text3145')}</h2>
        <p className="text-sm text-gray-500">{t('text3146')}</p>
        <Button onClick={() => router.push(ROUTES.SIGN_IN())}>{t('text189')}</Button>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
};
